const loadResponsiveTables = () => {
  if (document.querySelector('.table-toggler')) {
    const toggles = document.querySelectorAll('.table-toggler');

    toggles.forEach(toggle => {
      const parent = toggle.parentNode.parentNode;
      const dataResize = parent.getAttribute('data-resize') || '768';

      const initToggle = () => {
        if (parent.classList.contains('active')) {
          parent.classList.remove('active');
          toggle.classList.remove('active');
        } else {
          parent.classList.add('active');
          toggle.classList.add('active');
        }
      };

      toggle.addEventListener('click', initToggle);

      if (window.innerWidth >= dataResize) {
        toggle.removeEventListener('click', initToggle);
        toggle.classList.add('hide');
      } else {
        toggle.classList.remove('hide');
      }

      window.addEventListener('resize', () => {
        if (window.innerWidth >= dataResize) {
          toggle.removeEventListener('click', initToggle);
          toggle.classList.add('hide');
          toggle.classList.remove('active');
          parent.classList.remove('active');
        } else {
          toggle.addEventListener('click', initToggle);
          toggle.classList.remove('hide');
        }
      });
    });
  }
};

export default loadResponsiveTables;
